import styled, { css } from 'styled-components';
import { FormControlStyledProps } from './FormControl.types';
import { Textarea } from '../Textarea/Textarea.styled';

const Wrapper = styled.div(() => {
  return css`
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
  `;
});

const Control = styled.div<{ isInline: boolean }>(() => {
  return css`
    flex: 1 1 auto;
  `;
});

const FormLabel = styled.div(() => {
  return css`
    margin-bottom: 8px; // TODO: use theme color
  `;
});

const FormNotification = styled.div(() => {
  return css`
    display: flex;
    min-height: 16px;
    margin-top: 4px;
  `;
});

const getFormControlInline = (props: FormControlStyledProps) => {
  return css`
    ${FormLabel} {
      padding-left: 8px; // TODO: use theme color
      ${props.isInline && `margin-bottom: 0px`};
    }

    ${RequiredIndicator} {
      display: none;
    }
  `;
};

const RequiredIndicator = styled.span((props) => {
  return css`
    margin-inline-start: 2px;
    // color: ${props.theme.brand.error.base};
  `;
});

const FormControl = styled.div<FormControlStyledProps>((props) => {
  return css`
    font: inherit;
    position: relative;
    ${props.isInline && getFormControlInline};

    ${Textarea} {
      height: 100%;
    }
  `;
});

const InlineWrapper = styled.div`
  display: flex;
  align-items: start;
`;

export {
  FormControl,
  FormNotification,
  FormLabel,
  RequiredIndicator,
  Control,
  Wrapper,
  InlineWrapper,
};
